import { BlockRichText } from "../../../shared/components/BlockRichText/BlockRichText";
import type { IStatsItemProps } from "./StatsItem.props";

export const StatsItem = ({ description, label, value }: IStatsItemProps) => (
  <article className="min-w-0 border-t border-border pt-6 text-start">
    <p className="font-mono text-5xl/[0.98] tracking-[-0.025em] [overflow-wrap:anywhere] md:text-[76px]">
      {value}
    </p>
    <h3 className="mt-3 text-2xl/[1.15] font-semibold tracking-[-0.025em] [overflow-wrap:anywhere]">
      {label}
    </h3>
    {description ? (
      <BlockRichText
        className="mt-4 text-base/[1.55] text-onSurface-500 text-pretty [&_a]:underline [&_ol]:ml-5 [&_ol]:list-decimal [&_p+p]:mt-4 [&_ul]:ml-5 [&_ul]:list-disc"
        content={description}
      />
    ) : null}
  </article>
);

StatsItem.displayName = "Stats::StatsItem";
